import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    SxProps,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { headingFontBold, vars } from '../../../../Theme';

/** Styles for Dialog's component. */
const dialogSx: SxProps = {
    '& .MuiDialog-paper': {
        minWidth: '60%',
        py: 1,
    },
};

/** Styles for dialog's button. */
const dialogsButtonSx: SxProps = {
    textTransform: 'inherit',
    ...headingFontBold,
    '&:hover': {
        backgroundColor: 'transparent',
        color: vars.selectedHoveredGreen,
    },
};

/**
 * Dialog Component that warns users about closing the dialog without saving.
 */
export default ({
    open,
    handleClose,
    handleLeave,
    handleSaveChanges,
    title,
    text,
}: ILeaveConfirmDialogProps) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'leaveConfirmDialog' });

    const actionsBtnMapper = [
        {
            btn: 'cancel',
            callback: handleClose,
            styles: {
                color: vars.font,
                '&:hover': {
                    color: vars.black,
                    backgroundColor: 'transparent',
                },
            },
        },
        {
            btn: 'leave',
            callback: handleLeave,
            styles: {
                color: vars.font,
                '&:hover': {
                    color: vars.black,
                    backgroundColor: 'transparent',
                },
            },
        },
        {
            btn: 'saveChanges',
            callback: handleSaveChanges,
            styles: {},
        },
    ];

    return (
        <Dialog open={open} onClose={handleClose} sx={dialogSx}>
            <DialogTitle sx={{ fontSize: '18px', color: vars.font }}>{t(title)}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: vars.font }}>{t(text)}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 2 }}>
                {actionsBtnMapper.map(ac => (
                    <Button
                        key={ac.btn}
                        sx={{
                            ...dialogsButtonSx,
                            ...ac.styles,
                        }}
                        onClick={ac.callback}
                    >
                        {t(`${ac.btn}`)}
                    </Button>
                ))}
            </DialogActions>
        </Dialog>
    );
};

/**
 * Interface that describes LeaveConfirmDialog's props.
 */
interface ILeaveConfirmDialogProps {
    open: boolean;
    handleClose: () => void;
    handleLeave: () => void;
    handleSaveChanges: () => void;
    title: string;
    text: string;
}
